import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $item: document.getElementById('copy-link')
    };
    this.pageUrl = this.dom.$item.dataset.url;
  }

  addListeners() {
    this.dom.$item._on('click', this.onClick.bind(this))
  }

  onClick(e){
    e.preventDefault();
    navigator.clipboard.writeText(this.pageUrl);
    this.dom.$item.classList.add('active');

    setTimeout(() => {
      this.dom.$item.classList.remove('active');
    }, 4000)
  }
}

export default Module;
